import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { map, take, tap } from 'rxjs/operators';
import { AdminService } from '../services/admin.service';

@Injectable({
  providedIn: 'root'
})
export class AdminGuard implements CanActivate {
  
  constructor(
    private adminService: AdminService,
    private router: Router
  ) {}
  
  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> | Promise<boolean> | boolean {
    return this.adminService.currentAdmin.pipe(
      take(1),
      map(admin => !!admin),
      tap(isAdmin => {
        if (!isAdmin) {
          console.log('Accès refusé. Redirection vers la page de connexion administrateur.');
          this.router.navigate(['/admin/login']);
        }
      })
    );
  }
}
